import { forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  Avatar,
  AvatarProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    display: 'flex',
  },
});

export interface InputGroupAvatarProps
  extends Omit<AvatarProps, 'classes'>,
    WithStyles<typeof styles> {}

const InputGroupAvatar = forwardRef<HTMLDivElement, InputGroupAvatarProps>(
  ({ children, className, classes, ...rest }, ref) => {
    return (
      <Avatar
        ref={ref}
        className={classNames(classes.root, className)}
        data-slot="andornment"
        {...rest}
      >
        {children}
      </Avatar>
    );
  },
);

InputGroupAvatar.displayName = 'InputGroup.Avatar';

export default withStyles(styles)(InputGroupAvatar);
